'use client';

import { useSetAtom } from 'jotai';
import Image from 'next/image';
import Link from 'next/link';
import type { RouterOutputs } from 'trpc/shared';
import { imgLoader } from '~/shared/lib';
import { sidebarStateAtom } from '../model/state';

type CategoryLinkProps = {
    category: RouterOutputs['category']['getAll']['items'][number];
};

export const CategoryLinkSkeleton = () => {
    return <div className={'h-24 w-full animate-pulse bg-neutral-200'} />;
};

export const CategoryLink = ({ category }: CategoryLinkProps) => {
    const setState = useSetAtom(sidebarStateAtom);

    return (
        <Link
            href={{ pathname: '/products', query: { category: category.slug } }}
            className={'relative flex h-24 w-full items-center justify-between bg-neutral-200'}
            onClick={() => setState(prev => ({ ...prev, open: false }))}
        >
            <span className={'px-page font-600'}>{category.name}</span>
            <div>
                {!!category.image && (
                    <Image
                        loader={imgLoader({ src: category.image.key, width: 256 })}
                        src={category.image.key}
                        placeholder={'blur'}
                        blurDataURL={category.image.lqip ?? undefined}
                        className={'h-24 w-24 object-cover'}
                        alt={category.image.alt}
                        width={category.image.width ?? undefined}
                        height={category.image.height ?? undefined}
                    />
                )}
            </div>
        </Link>
    );
};
